<template>
  <v-app-bar app color="white" fixed height="65" style="z-index: 100">
    <div class="d-flex align-center header-image-box">
      <VlaanderenLogo class="header-image" />
    </div>

    <router-link class="text-decoration-none black--text ml-7" to="/">
      <v-toolbar-title class="font-weight-bold">{{ isLeeromgeving ? this.$t('app.leeromgeving') : this.$t('app.title') }}</v-toolbar-title>
    </router-link>

    <v-spacer></v-spacer>
    <v-skeleton-loader v-if="loading" class="flex" elevation="2" type="text" />
    <template v-else>
      <template v-if="isLoggedIn">
        <div class="header__content d-flex align-center">
          {{ gebruikerInfoService.volledigeNaam }}

          <template v-if="!gebruikerInfoService.controleur && gebruikerInfoService.erkenningsnummer">
            <v-divider class="mx-2" vertical inset />
            {{ gebruikerInfoService.erkenningsnummer }}
          </template>

          <template
            v-if="
              !gebruikerInfoService.controleur &&
              (gebruikerInfoService.geschorstDeskD || gebruikerInfoService.ingetrokkenDeskD)
            "
          >
            <v-divider class="mx-2" inset vertical />
            {{
              gebruikerInfoService.geschorstDeskD
                ? $t('algemeen.erkenning-info.status.geschorst')
                : $t('algemeen.erkenning-info.status.ingetrokken')
            }}
            <info-tooltip>
              <v-card>
                <v-card-text style="color: black">
                  {{
                    $t('algemeen.erkenning-info.information', {
                      status: (gebruikerInfoService.geschorstDeskD
                        ? $t('algemeen.erkenning-info.status.geschorst')
                        : $t('algemeen.erkenning-info.status.ingetrokken')
                      )
                        .toString()
                        .toLowerCase(),
                    })
                  }}
                </v-card-text>
              </v-card>
            </info-tooltip>
          </template>

          <template v-if="!gebruikerInfoService.controleur && gebruikerInfoService.ondernemingInfo">
            <v-divider class="mx-2" vertical inset />
            {{ gebruikerInfoService.ondernemingInfo }}
          </template>

          <template v-if="gebruikerInfoService.controleur && gebruikerInfoService.doelgroep">
            <v-divider class="mx-2" vertical inset />
            {{ gebruikerInfoService.doelgroep }}
          </template>

          <template v-if="!gebruikerInfoService.controleur && gebruikerInfoService.registratierollen">
            <v-divider class="mx-2" vertical inset />
            {{ gebruikerInfoService.registratierollen }}
          </template>

          <v-divider class="mx-2" vertical inset />

          <router-link to="/afmelden">{{ $t('links.afmelden') }}</router-link>

          <template>
            <v-divider class="mx-2" inset vertical />
            <router-link to="/wisselen">{{ $t('links.switchen') }}</router-link>
          </template>

          <router-link v-if="!isLoggedIn" to="/">{{ $t('links.aanmelden') }}</router-link>
        </div>
        <div class="header__content--mobile">
          <ProfileDropdown />
        </div>
      </template>
    </template>
  </v-app-bar>
</template>

<script lang="ts">
import { Component, Inject, Provide, Vue } from 'vue-property-decorator';
import VlaanderenLogo from '@/components/layout/VlaanderenLogo.vue';
import AuthService from '@/services/AuthorizationService';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import DialogCard from '@/components/dialog/DialogCard.vue';
import ProfileDropdown from '@/components/layout/ProfileDropdown.vue';
import InfoTooltip from '@/components/dialog/InfoTooltip.vue';
import GebruikerInfoService from '@/services/GebruikerInfoService';
import ConfigHelper from '@/util/ConfigHelper';

const auth = new AuthService();

@Component({
  components: { InfoTooltip, ProfileDropdown, DialogCard, Breadcrumbs, VlaanderenLogo },
})
export default class Header extends Vue {
  @Provide() isLoggedIn = false;
  @Provide() loading = false;
  @Inject('gebruikerInfoService') gebruikerInfoService: GebruikerInfoService;

  created() {
    if (process.env.NODE_ENV === 'development') {
      this.logInAndUpdateGebruiker();
    } else {
      auth.isLoggedIn().then(() => this.logInAndUpdateGebruiker());
    }
  }

  logInAndUpdateGebruiker() {
    this.loading = true;
    this.isLoggedIn = true;
    this.gebruikerInfoService.updateGebruikerDeskDWithGeschorstIngetrokkenToken().finally(() => (this.loading = false));
  }

  get isLeeromgeving(): boolean {
    return ConfigHelper.isLeeromgeving();
  }
}
</script>

<style scoped>
@media (width < 1000px) {
  .header__content {
    display: none !important;
  }
}

@media (width >= 1000px) {
  .header__content--mobile {
    display: none !important;
  }
}

.header__content .v-divider--vertical.v-divider--inset {
  height: 2.5rem;
  margin-top: 0;
}
</style>
